import React from 'react';
import styles from './AdminConfig.module.css';
import NavCard from '../../components/NavCard';
import { dashboard, health, client } from '../../../images';

const sprayerAvatar = '/images/sprayer-avatars/sprayer-avatar-8.png';

const AdminConfig = () => {
  return (
    <>
      <div>
        <div className={styles.gridContainer}>
          <div>
            <NavCard
              title="Summary Dashboard"
              actionText="View"
              icon={dashboard}
              link="/admin/summary-dashboard"
            />
          </div>
          <div>
            <NavCard
              title="Health"
              actionText="View"
              icon={health}
              link="/admin/health"
            />
          </div>
          <div>
            <NavCard
              title="Sprayers"
              actionText="Configure"
              icon={sprayerAvatar}
              link="/admin/sprayers"
            />
          </div>
          <div>
            <NavCard
              title="Clients"
              actionText="Configure"
              icon={client}
              link="/admin/clients"
            />
          </div>
          <div></div>
        </div>
      </div>
    </>
  );
};

export default AdminConfig;
